import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import type { BienRow } from "@/schemas/bien";

/**
 * Qualité 3 états pour le badge compact P/V/T (vert OK / orange "suffisant" /
 * rouge manquant).
 */
export const quality3 = (v: string | null | undefined): "ok" | "mid" | "ko" =>
  v === "bien" || v === "tres_bien" ? "ok" : v === "suffisant" ? "mid" : "ko";

/**
 * Badge compact Photos / Vidéo / Textes — 3 pastilles colorées pour gagner de
 * la place : vert = fait, orange = "suffisant" (à retravailler), rouge =
 * manquant. Textes est binaire (vert si textesOk, rouge sinon).
 *
 * Partagé entre la préparation Publication (PublicationWorkspacePage) et la
 * colonne P/V/T du Catalogue Location (BiensCataloguePage, demande Thibaud
 * 2026-08-20) — extrait dans son propre fichier pour éviter de dupliquer la
 * logique entre les deux pages.
 */
export function PvtBadge({ bien }: { bien: BienRow }) {
  const { t } = useTranslation();
  const cls = (s: "ok" | "mid" | "ko") =>
    s === "ok"
      ? "bg-success/15 text-success"
      : s === "mid"
        ? "bg-warning/15 text-warning"
        : "bg-danger/15 text-danger";
  const items: { l: string; s: "ok" | "mid" | "ko"; title: string }[] = [
    { l: "P", s: quality3(bien.photosOk), title: t("v2.publicationWs.pvt.photos") },
    { l: "V", s: quality3(bien.videoOk), title: t("v2.publicationWs.pvt.video") },
    { l: "T", s: bien.textesOk === true ? "ok" : "ko", title: t("v2.publicationWs.pvt.textes") },
  ];
  return (
    <div className="flex gap-1 justify-center">
      {items.map((it) => (
        <span
          key={it.l}
          title={it.title}
          className={cn(
            "inline-flex items-center justify-center w-5 h-5 rounded text-[10px] font-bold",
            cls(it.s),
          )}
        >
          {it.l}
        </span>
      ))}
    </div>
  );
}
